import { render, staticRenderFns } from "./features-type-groups.vue?vue&type=template&id=2e9daf2c"
import script from "./features-type-groups.vue?vue&type=script&lang=js"
export * from "./features-type-groups.vue?vue&type=script&lang=js"
import style0 from "./features-type-groups.vue?vue&type=style&index=0&id=2e9daf2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports